<div [ngStyle]="{ height: '100%', width: '100%' }" [style.min-height]="'400px'">
    <!-- <iframe  frameBorder="0"  *ngIf="showIframe"  [style.height]="iframeHeight" [src]="reportUrl" width="100%"> </iframe> -->

    <div [ngStyle]="{ height: '100%', width: '100%' }" #frame></div>

    <div *ngIf="isBusy" style="background: white; position: absolute; top: 0px; left: 0px; width: 100%; height: 100%" [style.display]="'grid'">
        <div class="sk-rotating-plane" [style.place-self]="'center center'"></div>
    </div>
</div>
